const toFiniteNumber = (value) => {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : 0;
};

const formatterCache = new Map();

const getFormatter = (minimumFractionDigits, maximumFractionDigits) => {
  const cacheKey = `${minimumFractionDigits}:${maximumFractionDigits}`;

  if (!formatterCache.has(cacheKey)) {
    formatterCache.set(cacheKey, new Intl.NumberFormat('de-DE', {
      minimumFractionDigits,
      maximumFractionDigits,
    }));
  }

  return formatterCache.get(cacheKey);
};

const formatWithLocale = (value, minimumFractionDigits, maximumFractionDigits) =>
  getFormatter(minimumFractionDigits, maximumFractionDigits).format(toFiniteNumber(value));

const parseLocaleNumber = (value, fallback = 0) => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : fallback;
  }

  const rawValue = String(value).trim().replace(/\s/g, '');
  if (!rawValue) {
    return fallback;
  }

  const normalizedValue = rawValue.includes(',')
    ? rawValue.replace(/\./g, '').replace(',', '.')
    : (/^\d{1,3}(\.\d{3})+$/.test(rawValue) ? rawValue.replace(/\./g, '') : rawValue);

  const parsedValue = Number(normalizedValue);
  return Number.isFinite(parsedValue) ? parsedValue : fallback;
};

export const normalizePositiveInteger = (value, fallback = 1) => {
  if (value === '' || value === null || value === undefined) {
    return fallback;
  }

  const numericValue = typeof value === 'number'
    ? value
    : Number(String(value).trim().replace(/\s/g, '').replace(/\./g, '').replace(',', '.'));
  if (!Number.isFinite(numericValue)) {
    return fallback;
  }

  return Math.max(Math.trunc(numericValue), 1);
};

export const formatInteger = (value) =>
  formatWithLocale(Math.trunc(parseLocaleNumber(value)), 0, 0);

export const formatPrice = (value) => `${formatWithLocale(value, 2, 2)} €`;

export const formatDiscount = (value) => {
  const numericValue = toFiniteNumber(value);
  const fractionDigits = Number.isInteger(numericValue) ? 0 : 2;

  return formatWithLocale(numericValue, fractionDigits, fractionDigits);
};

export const formatPercent = (value, fractionDigits = 1) =>
  formatWithLocale(value, fractionDigits, fractionDigits);
